import { gql } from '@apollo/client';

export const GET_WMS_PROGRESS_BY_PREVIOUS_STATION = gql`
  query GetWmsProgressByPreviousStation($filter: WmsProgressFilterInput!) {
    getWmsProgressByPreviousStation(filter: $filter) {
      sortingCode
      key
      hub
      whs
      area
      dspName
      total
      unPackNum
      packNum
      abnormalNum
      returnNum
      level
      previousHub
      previousWhs
      children {
        sortingCode
        key
        hub
        whs
        area
        dspName
        total
        unPackNum
        packNum
        abnormalNum
        returnNum
        level
        previousHub
        previousWhs
        children {
          sortingCode
          key
          hub
          whs
          area
          dspName
          total
          unPackNum
          packNum
          abnormalNum
          returnNum
          level
          previousHub
          previousWhs
        }
      }
    }
  }
`;

export interface WmsProgressByPreviousStationType {
  sortingCode: string;
  key: string;
  hub: string;
  whs: string;
  area: string;
  dspName?: string;
  total: number;
  unPackNum: number;
  packNum: number;
  abnormalNum: number;
  returnNum: number;
  level: string;
  previousHub?: string;
  previousWhs?: string;
  children: WmsProgressByPreviousStationType[];
}

export interface WmsProgressFilterInput {
  channelId?: number;
  currentWarehouseId: number;
  arrivedCurrentWarehouseDateRange?: {
    start: string;
    end: string;
  };
  carrierCode?: number;
}

export interface GetWmsProgressByPreviousStationResponse {
  getWmsProgressByPreviousStation: WmsProgressByPreviousStationType[];
}

